import { createAction, props } from '@ngrx/store';

export const initCustom = createAction('[Custom Page] Init');

// Action for getting Custom Material List
export const getCustomConversionList = createAction(
  '[custom/API] getCustomConversionList',
  props<{ payload: any; pathName?: any }>()
);
export const getCustomConversionListSuccess = createAction(
  '[custom/API] getCustomConversionList Success',
  props<{ customConversionList: any }>()
);
export const getCustomConversionListFailure = createAction(
  '[custom/API] getCustomConversionList Failure',
  props<{ error: any }>()
);
export const clearConversionList = createAction('[custom/API] clear conversion list');

// Action for getting Custom Truck List
export const getCustomTruckList = createAction(
  '[custom/API] getCustomTruckList',
  props<{ payload: any; pathName?: any }>()
);
export const getCustomTruckListSuccess = createAction(
  '[custom/API] getCustomTruckList Success',
  props<{ customTruckList: any }>()
);
export const getCustomTruckListFailure = createAction(
  '[custom/API] getCustomTruckList Failure',
  props<{ error: any }>()
);
export const clearTruckList = createAction('[custom/API] clear truck list');

// Action for getting Custom Reuse List
export const getCustomReuseList = createAction(
  '[custom/API] getCustomReuseList',
  props<{ payload: any; pathName?: any }>()
);
export const getCustomReuseListSuccess = createAction(
  '[custom/API] getCustomReuseList Success',
  props<{ customReuseList: any }>()
);
export const getCustomReuseListFailure = createAction(
  '[custom/API] getCustomReuseList Failure',
  props<{ error: any }>()
);
export const clearReuseList = createAction('[custom/API] clear reuse list');

// Action for getting Custom Storage List
export const getCustomStorageList = createAction(
  '[custom/API] getCustomStorageList',
  props<{ payload: any; pathName?: any }>()
);
export const getCustomStorageListSuccess = createAction(
  '[custom/API] getCustomStorageList Success',
  props<{ customStorageList: any }>()
);
export const getCustomStorageListFailure = createAction(
  '[custom/API] getCustomStorageList Failure',
  props<{ error: any }>()
);
export const clearStorageList = createAction('[custom/API] clear storage list');

// Action for getting Custom Filling List
export const getCustomFillingList = createAction(
  '[custom/API] getCustomFillingList',
  props<{ payload: any; pathName?: any }>()
);
export const getCustomFillingListSuccess = createAction(
  '[custom/API] getCustomFillingList Success',
  props<{ customFillingList: any }>()
);
export const getCustomFillingListFailure = createAction(
  '[custom/API] getCustomFillingList Failure',
  props<{ error: any }>()
);
export const clearFillingList = createAction('[custom/API] clear filling list');

// Action for getting Custom Transport List
export const getCustomTransportList = createAction(
  '[custom/API] getCustomTransportList',
  props<{ payload: any; pathName?: any }>()
);
export const getCustomTransportListSuccess = createAction(
  '[custom/API] getCustomTransportList Success',
  props<{ customTransportList: any }>()
);
export const getCustomTransportListFailure = createAction(
  '[custom/API] getCustomTransportList Failure',
  props<{ error: any }>()
);
export const clearTransportList = createAction('[custom/API] clear transport list');

// Action for getting Custom Waste Scenario List
export const getCustomWasteList = createAction(
  '[custom/API] getCustomWasteList',
  props<{ payload: any; pathName?: any }>()
);
export const getCustomWasteListSuccess = createAction(
  '[custom/API] getCustomWasteList Success',
  props<{ customWasteList: any }>()
);
export const getCustomWasteListFailure = createAction(
  '[custom/API] getCustomWasteList Failure',
  props<{ error: any }>()
);
export const clearCustomWasteList = createAction('[custom/API] clear customWaste list');
export const addCustomWasteScenarioExistingRecord = createAction(
  '[custom/API] clear customWaste list',
  props<{ error: any }>()
);

// Action for delete Custom Material
export const deleteCustomData = createAction(
  '[custom/API] Delete Custom Data',
  props<{ payload: any; customType: any; pathName: any; regionId: any }>()
);
export const deleteCustomDataSuccess = createAction(
  '[custom/API] Delete Custom Data Success',
  props<{ deleteCustomDataMessage: any; id: any }>()
);
export const deleteCustomDataFailure = createAction(
  '[custom/API] Delete Custom Data Failure',
  props<{ error: any }>()
);

//Action for adding material Ingredient in custom-material modal
export const addMaterialIngredient = createAction(
  '[custom/API] Add Material Ingredient',
  props<{ ingredient: any; action: any; ingredientIndex?: any }>()
);
export const updateMaterialIngredient = createAction(
  '[custom/API] Update Material Ingredient',
  props<{ ingredient: any; action: any; ingredientIndex?: any; nodeId?: any; colId?: any }>()
);
export const deleteMaterialIngredient = createAction(
  '[custom/API] Delete Material Ingredient',
  props<{ ingredient: any; action: any; ingredientIndex?: any }>()
);
export const copyMaterialIngredient = createAction(
  '[custom/API] Copy Material Ingredient',
  props<{ ingredient: any; action: any; ingredientIndex?: any }>()
);
export const materialIngredientSuccess = createAction(
  '[custom/API] getMaterialIngredient Success',
  props<{ materialList: any; errorMessage: any }>()
);
export const clearMaterialIngredient = createAction('[custom/API] clear material ingredient');
export const clearMaterialRowData = createAction('[custom/API] clear material row data');
export const clearMaterialList = createAction('[custom/API] clear material list');

//Action for adding material process in custom-material modal
export const addMaterialProcess = createAction(
  '[custom/API] Add Material Process',
  props<{ process: any; action: any; processIndex?: any }>()
);
export const updateMaterialProcess = createAction(
  '[custom/API] Update Material Process',
  props<{ process: any; action: any; processIndex?: any; nodeId?: any; colId?: any }>()
);
export const deleteMaterialProcess = createAction(
  '[custom/API] Delete Material Process',
  props<{ process: any; action: any; processIndex?: any }>()
);
export const copyMaterialProcess = createAction(
  '[custom/API] Copy Material Process',
  props<{ Process: any; action: any; ProcessIndex?: any }>()
);
export const materialProcessSuccess = createAction(
  '[custom/API] materialProcess Success',
  props<{ processList: any; errorMessage: any }>()
);
export const materialProcessFailure = createAction(
  '[custom/API] materialProcess Failure',
  props<{ error: any }>()
);
export const clearMaterialProcess = createAction('[custom/API] clear material process');

//Action for adding conversion process in custom-conversion modal
export const addConversionProcess = createAction(
  '[custom/API] Add conversion Process',
  props<{ process: any; action: any; processIndex?: any }>()
);
export const updateConversionProcess = createAction(
  '[custom/API] Update conversion Process',
  props<{ process: any; action: any; processIndex?: any; nodeId?: any; colId?: any }>()
);
export const deleteConversionProcess = createAction(
  '[custom/API] Delete conversion Process',
  props<{ process: any; action: any; processIndex?: any }>()
);
export const copyConversionProcess = createAction(
  '[custom/API] Copy conversion Process',
  props<{ process: any; action: any; processIndex?: any }>()
);
export const clearConversionProcess = createAction('[custom/API] clear conversion process');
// export const conversionProcess = createAction('[custom/API] conversionProcess', props<{ process: any, action: any , ingredientIndex?: any  }>());
// export const conversionProcessSuccess = createAction('[custom/API] conversionProcess Success', props<{ conversionProcessList: any, errorMessage: any }>());
// export const conversionProcessFailure = createAction('[custom/API] conversionProcess Failure', props<{ error: any }>());
// export const clearConversionProcess = createAction('[custom/API] clear conversion process');

//Action for delete Data custom component
export const deleteCustom = createAction(
  '[custom/API] deleteCustom',
  props<{ action: any; customType: any; pathName: any }>()
);
//Action for copying custom materials
export const customMaterialCopy = createAction(
  '[custom/API] customMaterialCopy',
  props<{ action: any; customType: any; pathName: any }>()
);
export const customMaterialCopySuccess = createAction(
  '[custom/API] customMaterialCopy Success',
  props<{ processList: any }>()
);
export const clearCustomMaterialCopy = createAction(
  '[custom/API] clear custom material copy process'
);

// Action for delete Custom Material
export const copyCustomData = createAction(
  '[custom/API] copyCustomData',
  props<{ payload: any; customType: any; pathName: any }>()
);
export const copyCustomDataSuccess = createAction(
  '[custom/API] copyCustomData Success',
  props<{ copyCustomDataMessage: any }>()
);
export const copyCustomDataFailure = createAction(
  '[custom/API] copyCustomData Failure',
  props<{ error: any }>()
);

//Reducer for add or edit custom material
export const addEditCustomMaterial = createAction(
  '[custom/API] Add edit custom material',
  props<{ customMaterialData: any }>()
);
export const addEditCustomMaterialSuccess = createAction(
  '[custom/API] Add edit custom material success',
  props<{ customMaterialData: any }>()
);
export const addEditCustomMaterialFailure = createAction(
  '[custom/API] Add edit custom material failure',
  props<{ error: any }>()
);

//Reducer for add or edit custom conversion
export const addEditCustomConversion = createAction(
  '[custom/API] Add edit custom conversion',
  props<{ customConversionData: any }>()
);
export const addEditCustomConversionSuccess = createAction(
  '[custom/API] Add edit custom conversion success',
  props<{ customConversionData: any }>()
);
export const addEditCustomConversionFailure = createAction(
  '[custom/API] Add edit custom conversion failure',
  props<{ error: any }>()
);

//Reducer for opening add/edit custom material modal
export const openAddEditCustomMaterialModal = createAction(
  '[custom/API] Open Add edit custom material Modal',
  props<{ customMaterialId?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditCustomMaterialModalSuccess = createAction(
  '[custom/API] Open Add edit custom material Modal success',
  props<{ customMaterialdata?: any }>()
);

//Reducer for opening add/edit custom conversion modal
export const openAddEditCustomConversionModal = createAction(
  '[custom/API] Open Add edit custom conversion Modal',
  props<{ customConversionId?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditCustomConversionModalSuccess = createAction(
  '[custom/API] Open Add edit custom conversion Modal success',
  props<{ customConversiondata?: any }>()
);
export const clearCustomConversionData = createAction('[custom/API] Clear custom conversion');

//Reducer for add or edit custom conversion
export const inlineDataEdit = createAction(
  '[custom/API] Inline Custom Data Edit',
  props<{ customData: any; module: any; pathName: any; nodeId?: any; field?: any }>()
);
export const inlineDataEditSuccess = createAction(
  '[custom/API] Inline Custom Data Edit Success',
  props<{ customData: any; module: any; field?: any }>()
);
export const inlineDataEditFailure = createAction(
  '[custom/API] Inline Custom Data Edit Failure',
  props<{ error: any }>()
);

//Reducer for add or edit custom material
export const addEditCustomFilling = createAction(
  '[custom/API] Add edit custom filling',
  props<{ customFillingData: any }>()
);
export const addEditCustomFillingSuccess = createAction(
  '[custom/API] Add edit custom filling success',
  props<{ customFillingData: any }>()
);
export const addEditCustomFillingFailure = createAction(
  '[custom/API] Add edit custom filling failure',
  props<{ error: any }>()
);

//Reducer for opening add/edit custom conversion modal
export const openAddEditCustomFiliingModal = createAction(
  '[custom/API] Open Add edit custom filling Modal',
  props<{ customFillingId?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditCustomFiliingModalSuccess = createAction(
  '[custom/API] Open Add edit custom filling Modal success',
  props<{ customFillingdata?: any }>()
);
export const ClearCustomFiliingData = createAction('[custom/API] Clear custom filling Modal data');

//Action for adding fillign Ingredient in custom-filling modal
export const addfillingIngredient = createAction(
  '[custom/API] Add filling Ingredient',
  props<{ ingredient: any; action: any; ingredientIndex?: any }>()
);
export const updatefillingIngredient = createAction(
  '[custom/API] Update filling Ingredient',
  props<{ ingredient: any; action: any; ingredientIndex?: any; nodeId?: any; colId?: any }>()
);
export const deletefillingIngredient = createAction(
  '[custom/API] Delete filling Ingredient',
  props<{ ingredient: any; action: any; ingredientIndex?: any }>()
);
export const copyfillingIngredient = createAction(
  '[custom/API] Copy filling Ingredient',
  props<{ ingredient: any; action: any; ingredientIndex?: any }>()
);
export const clearfillingIngredient = createAction('[custom/API] Clear filling process');
export const fillingFail = createAction('[custom/API] Clear filling Fail', props<{ error: any }>());

export const clearFillingIngredient = createAction('[custom/API] clear filling ingredient');
//Action for opening add/edit custom truck modal
export const openAddEditCustomTruckModal = createAction(
  '[custom/API] Open Add edit custom truck Modal',
  props<{ customTruckId?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditCustomTruckModalSuccess = createAction(
  '[custom/API] Open Add edit custom truck Modal success',
  props<{ customTruckdata?: any }>()
);
export const clearCustomTrucksData = createAction('[custom/API] Clear custom truck data');

//Action for opening add/edit custom truck modal
export const addEditCustomTruck = createAction(
  '[custom/API] Add edit custom truck',
  props<{ customTruckData: any }>()
);
export const addEditCustomTruckSuccess = createAction(
  '[custom/API] Add edit custom truck success',
  props<{ customTruckData: any }>()
);
export const addEditCustomTruckFailure = createAction(
  '[custom/API] Add edit custom truck failure',
  props<{ error: any }>()
);

//Action for opening add/edit custom transport scenario modal
export const openAddEditCustomTransportScenarioModal = createAction(
  '[custom/API] Open Add edit custom transport scenario Modal',
  props<{ customTransportScenarioId?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditCustomTransportScenarioModalSuccess = createAction(
  '[custom/API] Open Add edit custom transport scenario Modal success',
  props<{ customTransportScenarioData?: any; transportFinalGrid?: any }>()
);

export const addEditCustomTransportScenario = createAction(
  '[custom/API] Add edit custom transport scenario',
  props<{ customTransportScenarioData: any }>()
);
export const addEditCustomTransportScenarioSuccess = createAction(
  '[custom/API] Add edit custom transport scenario success',
  props<{ customTransportScenarioData: any }>()
);
export const addEditCustomTransportScenarioFailure = createAction(
  '[custom/API] Add edit custom transport scenario failure',
  props<{ error: any }>()
);
//Reducer for add or edit custom material
export const addEditCustomStorage = createAction(
  '[custom/API] Add edit custom storage',
  props<{ customStorageData: any }>()
);
export const addEditCustomStorageSuccess = createAction(
  '[custom/API] Add edit custom storage success',
  props<{ customStorageData: any }>()
);
export const addEditCustomStorageFailure = createAction(
  '[custom/API] Add edit custom storage failure',
  props<{ error: any }>()
);

//Reducer for opening add/edit custom storage modal
export const openAddEditCustomStorageModal = createAction(
  '[custom/API] Open Add edit custom storage Modal',
  props<{ customStorageId?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditCustomStorageModalSuccess = createAction(
  '[custom/API] Open Add edit custom storage Modal success',
  props<{ customStoragedata?: any }>()
);
export const ClearAddEditCustomStorageModal = createAction(
  '[custom/API] Clear custom storage Modal'
);

//Action for adding storage process in custom-storage modal
// export const storageProcess = createAction('[custom/API] storageProcess', props<{ ingredient: any, action: any, ingredientIndex?: any }>());
// export const storageProcessSuccess = createAction('[custom/API] storageProcess Success', props<{ storageList: any, errorMessage: any }>());

export const addStorageProcess = createAction(
  '[custom/API] Add storage Process',
  props<{ process: any; action: any; processIndex?: any }>()
);
export const updateStorageProcess = createAction(
  '[custom/API] Update storage Process',
  props<{ process: any; action: any; processIndex?: any; nodeId?: any; colId?: any }>()
);
export const deleteStorageProcess = createAction(
  '[custom/API] Delete storage Process',
  props<{ process: any; action: any; processIndex?: any }>()
);
export const copyStorageProcess = createAction(
  '[custom/API] Copy storage Process',
  props<{ process: any; action: any; processIndex?: any }>()
);
export const storageProcessFailure = createAction(
  '[custom/API] storageProcess Failure',
  props<{ error: any }>()
);
export const clearStorageProcess = createAction('[custom/API] Clear storage process');

//Reducer for add or edit custom material
export const addEditCustomWasteScenario = createAction(
  '[custom/API] Add edit custom waste scenario',
  props<{ customWasteScenarioData: any }>()
);
export const addEditCustomWasteScenarioSuccess = createAction(
  '[custom/API] Add edit custom waste scenario success',
  props<{ customWasteScenarioData: any }>()
);
export const addEditCustomWasteScenarioFailure = createAction(
  '[custom/API] Add edit custom waste scenario failure',
  props<{ error: any }>()
);

//Reducer for opening add/edit custom storage modal
export const openAddEditCustomWasteScenarioModal = createAction(
  '[custom/API] Open Add edit custom waste scenario Modal',
  props<{ customWasteScenarioId?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditCustomWasteScenarioModalSuccess = createAction(
  '[custom/API] Open Add edit custom waste scenario Modal success',
  props<{ customWasteScenarioData?: any }>()
);
export const clearCustomWasteScenarioModal = createAction(
  '[custom/API] Clear custom waste scenario data'
);

// Action for adding store process in custom waste scenarios code-refactor
export const addWasteScenarioDataProcess = createAction(
  '[custom/API] Add waste scenario',
  props<{ ingredient: any; action: any; ingredientIndex?: any; wasteGridData?: any }>()
);
export const updateWasteScenarioDataProcess = createAction(
  '[custom/API] Update waste scenario',
  props<{
    ingredient: any;
    action: any;
    ingredientIndex?: any;
    nodeId?: any;
    colId?: any;
    wasteGridData?: any;
  }>()
);
export const deleteWasteScenarioDataProcess = createAction(
  '[custom/API] Delete waste scenario',
  props<{ ingredient: any; action: any; ingredientIndex?: any; wasteGridData?: any }>()
);
export const copyWasteScenarioDataProcess = createAction(
  '[custom/API] Copy waste scenario',
  props<{ ingredient: any; action: any; ingredientIndex?: any; wasteGridData?: any }>()
);
export const wasteScenarioProcessGrid = createAction(
  '[custom/API]  waste scenario Grid Data',
  props<{ wasteGridData?: any; wasteDataList: any }>()
);
export const clearWasteScenariProcess = createAction('[custom/API] clear material ingredient');
export const clearWasteScenarioRowDataProcess = createAction('[custom/API] clear waste row data');
export const clearWasteScenarioListProcess = createAction('[custom/API] clear waste scenario list');

//Action for Custom Reuse Add Edit
export const openAddEditCustomReuseModal = createAction(
  '[custom/API] Open Add edit custom reuse Modal',
  props<{ customReuseId?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditCustomReuseModalSuccess = createAction(
  '[custom/API] Open Add edit custom reuse Modal success',
  props<{ customReuseData?: any }>()
);
export const clearCustomReuseModal = createAction('[custom/API] clear custom reuse Modal data');

export const addEditCustomReuse = createAction(
  '[custom/API] Add edit custom reuse',
  props<{ customReuseData: any }>()
);
export const addEditCustomReuseSuccess = createAction(
  '[custom/API] Add edit custom reuse success',
  props<{ customReuseData: any }>()
);
export const addEditCustomReuseFailure = createAction(
  '[custom/API] Add edit custom reuse failure',
  props<{ error: any }>()
);

//Custom reuse
export const addReuseIngredient = createAction(
  '[custom/API] Add Reuse Ingredient',
  props<{ ingredient: any; action: any; ingredientIndex?: any }>()
);
export const updateReuseIngredient = createAction(
  '[custom/API] Update Reuse Ingredient',
  props<{ ingredient: any; action: any; ingredientIndex?: any; nodeId?: any; colId?: any }>()
);
export const deleteReuseIngredient = createAction(
  '[custom/API] Delete Reuse Ingredient',
  props<{ ingredient: any; action: any; ingredientIndex?: any }>()
);
export const copyReuseIngredient = createAction(
  '[custom/API] Copy Reuse Ingredient',
  props<{ ingredient: any; action: any; ingredientIndex?: any }>()
);
export const reuseIngredientFailure = createAction(
  '[custom/API] storageProcess Failure',
  props<{ error: any }>()
);
export const clearReuseIngredient = createAction('[custom/API] Clear storage process');

//Actions for custom Transport Scenario
export const addTransportScenario = createAction(
  '[custom/API] Add Transport Scenario',
  props<{ transport: any; action: any; index?: any }>()
);
export const updateTransportScenarioActions = createAction(
  '[custom/API] Update Transport Scenario',
  props<{ transport: any; action: any; index?: any }>()
);
export const deleteTransportScenario = createAction(
  '[custom/API] Delete TransportScenario',
  props<{ transport: any; action: any; index?: any }>()
);
export const clearAddTransportScenario = createAction('[custom/API] clear transport scenario');
export const clearTransportScenarioRowData = createAction(
  '[custom/API] clear transport scenario row data'
);

export const addMultipleTransportScenario = createAction(
  '[custom/API] Add multiple transport Scenario',
  props<{ multiTransport: any; action: any; index?: any }>()
);
export const addMultipleTransportScenarioScenarioFailure = createAction(
  '[custom/API] Add edit multiple transport scenario failure',
  props<{ error: any }>()
);
export const deleteMultipleTransportScenario = createAction(
  '[custom/API] Delete multiple transport scenario',
  props<{ multiTransport: any; action: any; index?: any; remainingValue?: any }>()
);
export const clearAddMultipleTransportScenario = createAction(
  '[custom/API] clear multiple transport scenario'
);

export const checkUpdateActionFire = createAction(
  '[custom/API] update action fire',
  props<{ check: boolean }>()
);
export const clearnDistanceError = createAction('[custom/API] clean distance error');
